import { notification } from "antd";
import { isArray, isEmpty } from "lodash";
import axios from '../../axios_config';
import { toast } from "../hooks/use-toast";

export const handleRejectedResponse = (err, errorType, rejectWithValue, showNotification = true, showNewToaster = false) => {
  if (!showNotification) {
    return rejectWithValue({ statusCode: err?.response?.status, message: (errorMessage || err.message) });
  };
  const { response } = err || {};
  const { data } = response || {};
  const { error, errors, card, message: cardMessage, errorData } = data || {};
  const shipmentNotFoundError = (typeof cardMessage === 'string') ? '' : cardMessage?.errors?.[0]?.message || {};
  const { generalErrors, invalidSkus } = errors || {};
  const errMessage = isArray(error) ? error[0] : error;
  const { message } = errors?.[0] || {};
  const { errors: cardError } = card || {}
  const { message: cardErr } = cardError?.[0] || {}

  const errorMessage = shipmentNotFoundError || cardErr || message || cardMessage || errors || errMessage || err.message || 'Unknown Error';

  if (isEmpty(errorData)) {
    if (!isEmpty(generalErrors)) {
      !(axios.isCancel(err)) && (showNewToaster ? toast({
        title: errorType,
        description: generalErrors?.[0],
        variant: "destructive",
      }) : notification.error({
        message: errorType,
        description: generalErrors?.[0],
        placement: "topRight",
        top: 65,
        duration: 5,
      }));
    }
    else {
      !(axios.isCancel(err)) && (showNewToaster ? toast({
        title: errorType,
        description: errorMessage,
        variant: "destructive",
      }) : notification.error({
        message: errorType,
        description: errorMessage,
        placement: "topRight",
        top: 65,
        duration: 5,
      }));
    }
  }

  return rejectWithValue({ statusCode: err.response?.status, message: (errorMessage || err.message), errorData, invalidSkus });
}
